<div class="map-page-container">
  <iframe
    *ngIf="mapId != undefined"
    [src]="getSafeMapUrl()"
    width="100%"
    height="100%"
    style="border:none;"
    loading="lazy">
  </iframe>
<!--  <div class="header-mob-container">-->
<!--    <div class="header-mob-el-container">-->
<!--      <app-icon [icon]="Icons.crossClose" [invert]="getInvert()" (click)="navigationService.backOrHome();"/>-->
<!--    </div>-->
<!--  </div>-->
</div>
